export enum RegistrationSteps {
    Personal = 'personal-details',
    Professional = 'professional-details',
    Contact = 'contact-details',
    Identity = 'identity',
    Address = 'finish',
}
